<script setup lang="ts">
import Card from 'primevue/card';
import Message from 'primevue/message';
import KpTextField from '@/components/KpTextField.vue';
import KpButton from '@/components/KpButton.vue';
import { reactive } from 'vue';

defineProps({
    footerText: {
        type: String,
        default: '',
    },
    error: {
        type: String,
        default: '',
    },
    loading: {
        type: Boolean,
        default: false,
    },
});

defineEmits(['login']);

const state = reactive({
    username: '',
    password: '',
});
</script>

<template>
    <Card class="mt-5rem" style="width: 25rem; overflow: hidden; margin-left: auto; margin-right: auto">
        <template #title>ECO<sub>2</sub>Stat: {{ $t('anmelden') }}</template>
        <template #content>
            <KpTextField
                v-model="state.username"
                :label="$t('benutzername')"
                name="username"
                input-class="w-full"
                @enter="$emit('login', state)"
            />
            <KpTextField
                v-model="state.password"
                :label="$t('passwort')"
                name="password"
                input-type="password"
                input-class="w-full"
                @enter="$emit('login', state)"
            />
        </template>
        <template #footer>
            <div class="flex gap-4 mt-1">
                <KpButton
                    :diabled="!state.username || !state.password"
                    :label="$t('anmelden')"
                    class="w-full"
                    icon="far fa-right-to-bracket"
                    iconPos="right"
                    :loading="loading"
                    @click="$emit('login', state)"
                />
            </div>
            <Message v-if="error" severity="error" class="w-full my-1rem">{{ error }}</Message>
            <div class="w-full mt-2rem text-center" v-html="footerText"></div>
        </template>
    </Card>
</template>
